import {jsx} from 'panel';

import {QueryBlockEl} from 'common/widgets/query-block';

import type {QueryEntrySection} from '../index';
import {FiltersOperator, QueryBehaviorEntry} from '../types';

export function BehaviorRowDateRange({
  el,
  entry,
  index,
}: {
  el: QueryEntrySection;
  entry: QueryBehaviorEntry;
  index: number;
}) {
  /**
   * A funnel based behavior defines the conversion window to be the first date range from the first
   * funnel step, changing the date on subsequent steps has no effect so we hide it
   */
  const hideTimeSelector = entry.behavioralFiltersOperator === FiltersOperator.Then && index !== 0;

  return (
    !hideTimeSelector && (
      <QueryBlockEl
        attrs={{
          type: `time`,
          elref: `behaviorTimeBlock`,
          'display-context': el.attr(`time-display-context`),
          'max-data-history-days': el.attr(`max-data-history-days`),
          'selector-icon': `calendar`,
          'selector-type': `button`,
          'project-id': el.attr(`project-id`),
          'workspace-id': el.attr(`workspace-id`),
          'hide-prefix-label': true,
          selected: entry.dateRange || el.helpers.getDefaultDateValue(),
          theme: `select`,
          'project-as-of-date': el.attr(`project-as-of-date`),
        }}
        on={{
          select: (ev: CustomEvent) => el.helpers.onDateRangeChange(ev, index),
          track: el.helpers.preventTracking,
        }}
      />
    )
  );
}
